<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    CONVÊNIO
                    <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <div>
                    <b-row>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label for="vcCodigoEstruturado" class="required">Nº do Convênio</label>
                                <b-input-group>
                                        <b-form-input
                                            id="vcCodigoEstruturado"
                                            type="text"
                                            placeholder="Nº do Convênio"
                                            v-model="convenio.vcCodigoEstruturado"
                                            v-mask="'AA###/##'"
                                            :disabled="!habilitaCampos"
                                        ></b-form-input>
                                        <b-form-invalid-feedback>Nº do Convênio é obrigatório</b-form-invalid-feedback>
                                    </b-input-group>
                            </b-form-group>
                        </b-col>
                        <!-- <b-col sm="12" md="2">
                            <b-form-group>
                                <label for="IdProcessoAta">Ata Direx</label>
                                <b-input-group>
                                        <b-form-input
                                            id="IdProcessoAta"
                                            type="text"
                                            placeholder="Ata Direx"
                                            v-model="convenio.processoAta.ataDirex.nuAtaDirex"
                                            :disabled="!habilitaCampos"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button
                                                variant="primary"
                                                @click="pesquisarAtaDirex()"
                                                title="Clique para pesquisar a Ata Direx"
                                                :disabled="!habilitaCampos"
                                            >
                                                <i class="fa fa-search"></i>
                                            </b-button>
                                        </b-input-group-append>
                                        <b-form-invalid-feedback>Ata Direx é obrigatório</b-form-invalid-feedback>
                                    </b-input-group>
                            </b-form-group>
                        </b-col> -->
                        <!-- <b-col sm="12" md="2">
                            <b-form-group>
                                <label for="idProcesso">Nº Processo</label>
                                <b-input-group>
                                        <b-form-select
                                            id="idProcesso"
                                            type="text"
                                            placeholder="Nº Processo"
                                            v-model="convenio.idProcessoAta"
                                            :options="convenio.processosAta"
                                            value-field="idProcessoAta"
                                            text-field="nuProcesso"
                                            :disabled="!habilitaCampos"
                                        ></b-form-select>
                                        <b-form-invalid-feedback>Nº Processo é obrigatório</b-form-invalid-feedback>
                                    </b-input-group>
                            </b-form-group>
                        </b-col> -->
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="12">
                            <b-form-group>
                                <label for="vcObjeto" class="required">Objeto</label>
                                <b-input-group>
                                    <b-form-textarea
                                        id="vcObjeto"
                                        type="text"
                                        v-model="convenio.vcObjeto"
                                        placeholder="Objeto"
                                        :rows="2"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback>Objeto é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label for="cnpj" class="required">Convenente</label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        id="cnpj"
                                        v-model="convenio.convenenteRM.cnpj"
                                        placeholder="CNPJ"
                                        v-mask="[
                                            '##.###.###/####-##'
                                        ]"
                                        :disabled="!habilitaCampos"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button
                                            variant="primary"
                                            @click="pesquisarConvenente()"
                                            title="Clique para pesquisar o Convenente"
                                            :disabled="!habilitaCampos"
                                        >
                                        <i class="fa fa-search"></i>
                                        </b-button>
                                    </b-input-group-append>
                                    <b-form-invalid-feedback>Convenente é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="10">
                            <b-form-group>
                                <label for="nome">Razão Social</label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        id="nome"
                                        placeholder="Razão Social"
                                        v-model="convenio.convenenteRM.nome"
                                        :disabled="true"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label for="nuValorConvenio">Valor Total</label>
                                <b-input-group>
                                    <money
                                        id="nuValorConvenio"
                                        v-model="convenio.nuValorConvenio"
                                        v-bind="money"
                                        class="form-control text-right"
                                        :disabled="true"
                                    ></money>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label for="nuValorReceitaPrevista" class="required">Receita Prevista</label>
                                <b-input-group>
                                    <money
                                        id="nuValorReceitaPrevista"
                                        v-model="convenio.nuValorReceitaPrevista"
                                        v-bind="money"
                                        class="form-control text-right"
                                    ></money>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label for="dtInicioVigencia" class="required">Vigência Inicial</label>
                                <b-input-group>
                                    <date-picker
                                        id="dtInicioVigencia"
                                        v-model="convenio.dtInicioVigencia"
                                        @input.native="$v.convenio.dtInicioVigencia.$touch()"
                                        :config="$datePickerOptions"
                                        v-mask="'##/##/####'"
                                    ></date-picker>
                                    <b-form-invalid-feedback>Vigência inicial é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label for="dtFimVigencia" class="required">Vigência Final</label>
                                <b-input-group>
                                    <date-picker
                                        id="dtFimVigencia"
                                        v-model="convenio.dtFimVigencia"
                                        @input.native="$v.convenio.dtFimVigencia.$touch()"
                                        :config="$datePickerOptions"
                                        v-mask="'##/##/####'"
                                    ></date-picker>
                                    <b-form-invalid-feedback>Vigência final é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label >Gestor</label>
                                <b-input-group>
                                    <b-form-select
                                        id="codGestor"
                                        v-model="convenio.codGestor"
                                        type="text"
                                        :options="gestores"
                                        value-field="codFuncionario"
                                        text-field="nome"
                                        :disabled="!habilitaCampos"
                                    >
                                    </b-form-select>
                                    <b-form-invalid-feedback>Gestor é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <!-- <b-col sm="12" md="6">
                            <b-form-group>
                                <label for="codUnidade">Unidade</label>
                                <b-input-group>
                                    <b-form-select
                                        id="codUnidade"
                                        v-model="convenio.codUnidade"
                                        type="text"
                                        :options="unidades"
                                        value-field="codUnidade"
                                        text-field="nome"
                                        :disabled="!habilitaCampos"
                                    ></b-form-select>
                                    <b-form-invalid-feedback>Unidade é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col> -->
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="4" lg="4" xl="4">
                            <b-form-group>
                                <label>Tipo Convênio
                                    <b-badge variant="primary" class="ml-2">Integração com RM</b-badge>
                                </label>
                                <b-form-select
                                    :options="tiposConveniosRm"
                                    v-model="convenio.codTipoConvenio"
                                    text-field="descricao"
                                    value-field="codigo"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4" xl="4">
                            <b-form-group>
                                <label>Tipo para Faturamento <b-badge variant="primary" class="ml-2">Integração com RM</b-badge></label>
                                <b-form-select
                                    :options="tiposProdutosFaturamentoRm"
                                    v-model="convenio.codTipoProdutoFaturamento"
                                    text-field="descricao"
                                    value-field="codigo"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4" xl="4">
                            <b-form-group>
                                <label>Natureza <b-badge variant="primary" class="ml-2">Integração com RM</b-badge></label>
                                <b-form-select
                                    :options="tiposNatureza"
                                    text-field="descricao"
                                    value-field="codigo"
                                    v-model="convenio.codTipoNatureza"
                                >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="4" lg="4" xl="4">
                            <b-form-group>
                                <label>Gestor do Convênio <b-badge variant="primary" class="ml-2">Integração com RM</b-badge></label>
                                <b-form-select
                                    :options="vendedores"
                                    v-model="convenio.codGestorRM"
                                    text-field="nome"
                                    value-field="codigo"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4" xl="4">
                            <b-form-group>
                                <label>Gerente do gestor <b-badge variant="primary" class="ml-2">Integração com RM</b-badge></label>
                                <b-form-select
                                    :options="vendedores"
                                    v-model="convenio.codGerenteGestor"
                                    text-field="nome"
                                    value-field="codigo"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4" xl="4">
                            <b-form-group>
                                <label>Representante <b-badge variant="primary" class="ml-2">Integração com RM</b-badge></label>
                                <b-form-select
                                    :options="representantes"
                                    text-field="nome"
                                    value-field="codigo"
                                    v-model="convenio.codRepresentante"
                                >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
            <b-card-footer>
                <b-button
                    variant="primary"
                    class="mr-2"
                    :disabled="this.$v.$invalid"
                    @click.stop="salvar()">
                    <span>
                        <i class="fa fa-save mr-2"></i> Salvar
                    </span>
                </b-button>
                <b-button variant="danger" @click.stop="voltar()" class="mr-2">
                    <span>
                        <i class="fa fa-history mr-2"></i> Voltar
                    </span>
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ConveniosServicos from '../ConveniosServicos'

export default {

    validations: {
        /* Validação do Valor Realizado no Objeto, campo nuValorReceitaPrevista
        valor: {
            required,
            minValue: minValue(0.01)
        },*/

        
        // idProcessoAta:{required},

        /* Verificar se estes campos são mesmo obrigatórios
        codGestor:{required},
        codUnidade:{required},
        codTipoConvenio:{required},
        codTipoProdutoFaturamento:{required},
        codTipoNatureza:{required},
        codGestorRM:{required},
        codGerenteGestor:{required},
        codRepresentante:{required},
        */

        convenio:{
            vcCodigoEstruturado : {required},
            vcObjeto : {required},
            dtInicioVigencia : {required},
            dtFimVigencia : {required},
            nuValorReceitaPrevista : {required, minValue: minValue(0.01)},
            convenenteRM : {
                cnpj : {required},
                nome : {required}
            },
            // processoAta : {
            //     ataDirex:{
            //         nuAtaDirex : {required}
            //     }
            // }
        }
    },

    data() {
        return {
            tiposConveniosRm: [],
            tiposProdutosFaturamentoRm: [],
            tiposNatureza: [],
            vendedores: [],
            representantes: [],
            habilitaCampos: true,
            tabIndex: 0,
            operacao: '',
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            erros: [],
            gestores: [],
            itensPorPagina: 5,
            
            
            codGestor : null,
            codTipoConvenio : null,
            codTipoProdutoFaturamento : null,
            codTipoNatureza : null,
            codGestorRM : null,
            codGerenteGestor : null,
            codRepresentante : null,
            // unidades: [],
            // idProcessoAta : null,
            // codUnidade : null,

            convenio: {
                idConvenio: 0,
                vcObjeto: '',
                vcCodigoEstruturado: '',
                codConvenente: 0,
                codGestor: 0,
                idSituacaoConvenio: 1,
                convenenteRM: {
                    cnpj: '',
                    codFornecedor: '',
                    email: '',
                    nome: '',
                    telefone: ''
                },
                gestor: {
                    codFuncionario: 0,
                    CodNomeFuncionario: 0,
                    nome: '',
                    email: ''
                },
                dtInicioVigencia: '',
                dtFimVigencia: '',
                nuValorReceitaPrevista: 0.00,
                totalReceitas: 0.00,
                totalRendimentos: 0.00,
                nuValorConvenio: 0.00,
                // processosAta: [],
                // idProcessoAta: 0,
                // codUnidade: 0,
                
                
                // processoAta: {
                //     id: 0,
                //     idAtaDirex: 0,
                //     vcObjetoProcesso: '',
                //     vcNomeSolicitanteGdoc: '',
                //     nuProcesso: '',
                //     ataDirex: {
                //         cdTipoAta: 0,
                //         cdTipoProcessoAta: null,
                //         dtCadastro: null,
                //         dtReuniao: null,
                //         idAtaDirex: 0,
                //         idSolicitanteRm: null,
                //         idUnidadeRm: null,
                //         nuAtaDirex: '',
                //         nuSituacaoAta: 0,
                //         nuValorTotalAta: null,
                //         txObjeto: '',
                //         usrLogin: '',
                //     }
                // },
                // unidade: {
                //     codUnidade: '',
                //     nome: ''
                // },
            },
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'Convenios' })
        },

        editarConvenio(id) {
                this.$router.push({
                name: 'Convenios_Detalhar',
                params: {
                    convenioId: id
                }
            })
        },

        obterConvenio() {
                this.habilitaCampos = true
                // this.idProcessoAta = null
                this.codGestor = null
                // this.codUnidade = null
                this.codTipoConvenio = null
                this.codTipoProdutoFaturamento = null
                this.codTipoNatureza = null
                this.codGestorRM = null
                this.codGerenteGestor = null
                this.codRepresentante = null


                if (this.$route.params.convenioId > 0){
                    this.operacao = "EDIÇÃO"
                    this.habilitaCampos = false

                    this.$store.dispatch('addRequest')
                    ConveniosServicos.obterPorId(this.$route.params.convenioId).then(
                        response => {
                            if (response) {
                                if (response.success) {
                                    this.convenio = response.data
                                    this.habilitaAplicacaoRecursoAcao = response.data.tipoAplicacaoRecurso=="A"
                                    this.convenio.dtInicioVigencia = this.$moment(response.data.dtInicioVigencia).format('DD/MM/YYYY')
                                    this.convenio.dtFimVigencia = this.$moment(response.data.dtFimVigencia).format('DD/MM/YYYY')
                                    this.convenio.gestor = response.data.gestor
                                    this.convenio.codGestor = response.data.codGestor
                                    // this.convenio.gestor.nome = response.data.gestor.nome
                                    // this.convenio.gestor.CodNomeFuncionario = response.data.gestor.CodNomeFuncionario
                                    this.codTipoConvenio = response.data.codTipoConvenio
                                    this.codTipoProdutoFaturamento = response.data.codTipoProdutoFaturamento
                                    this.codTipoNatureza = response.data.codTipoNatureza
                                    this.codGestorRM = response.data.codGestorRM
                                    this.codGerenteGestor = response.data.codGerenteGestor
                                    this.codRepresentante = response.data.codRepresentante
                                    // this.pesquisarAtaDirex()
                                    // this.idProcessoAta = response.data.idProcessoAta
                                    // this.codUnidade = response.data.codUnidade
                                } else {
                                    this.erros = response.errors
                                }
                            }
                            this.$store.dispatch('removeRequest')
                        }
                    )
                }else{
                    this.operacao = "INSERÇÃO"
                }
            },

        salvar(){
            this.convenio.dtInicioVigencia = this.$moment(this.convenio.dtInicioVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD')
            this.convenio.dtFimVigencia = this.$moment(this.convenio.dtFimVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD')

            if (this.operacao == "INSERÇÃO"){
                this.$store.dispatch('addRequest')
                ConveniosServicos.inserirConvenio(this.convenio)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.convenio = response.data
                            this.editarConvenio(response.data.idConvenio)
                            this.obterConvenio()
                            this.$emit('obterConvenios')
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }else{
                this.$store.dispatch('addRequest')
                ConveniosServicos.AlterarConvenio(this.convenio)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.convenio = response.data
                            //this.editarConvenio(response.data.idConvenio)
                            this.obterConvenio()
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }

        },

        obterGestores(){
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterGestores().then(
                response => {
                        if (response) {
                            if (response.success) {
                                this.gestores = response.data
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
            )
        },

        // obterUnidades(){
        //     this.$store.dispatch('addRequest')
        //     ConveniosServicos.obterUnidades().then(
        //         response => {
        //                 if (response) {
        //                     if (response.success) {
        //                         this.unidades = response.data
        //                     } else {
        //                         this.erros = response.errors
        //                     }
        //                 }
        //                 this.$store.dispatch('removeRequest')
        //             }
        //     )
        // },

        // pesquisarAtaDirex() {
        //     if (this.convenio.processoAta.ataDirex.nuAtaDirex.length == 7) {

        //         this.$store.dispatch('addRequest')
        //         ConveniosServicos.obterProcessosPorNumeroAta(
        //             this.convenio.processoAta.ataDirex.nuAtaDirex.replace('/', '-')
        //         ).then(response => {
        //             if (response) {
        //                 if (response.success && response.data != null) {
        //                     this.erros = []
        //                     this.convenio.processosAta = response.data
        //                 } else {
        //                     this.convenio.processosAta = []
        //                     this.erros = response.errors
        //                 }
        //             }
        //             this.$store.dispatch('removeRequest')
        //         })
        //     }
        // },

        pesquisarConvenente() {
            if (this.convenio.convenenteRM.cnpj.length == 14 || this.convenio.convenenteRM.cnpj.length == 18)
            {
                let cpfcnpjSemCaracteresEspeciais = this.convenio.convenenteRM.cnpj.replace(/\D+/g, '')
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterFornecedor(cpfcnpjSemCaracteresEspeciais)
                .then(response => {
                    if (response) {
                        if (response.success && response.data != null) {

                            this.erros = []
                            this.convenio.codConvenente = response.data.codFornecedor
                            this.convenio.convenenteRM.nome = response.data.nome
                            this.convenio.convenenteRM.codFornecedor = response.data.codFornecedor
                        } else {
                            this.erros.push('Convenente não encontrado')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterTiposConvenios() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterTiposConveniosRM().then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposConveniosRm = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterTipoProdutoFaturamento() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterTipoProdutoFaturamentoRM().then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposProdutosFaturamentoRm = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterTipoNatureza() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ObterTipoNaturezaRM().then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposNatureza = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterVendedores() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ObterVendedoresRM().then(response => {
                if (response) {
                    if (response.success) {
                        this.vendedores = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterRepresentantes() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ObterRepresentantesRM().then(response => {
                if (response) {
                    if (response.success) {
                        this.representantes = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },


    watch: {
        // 'convenio.idProcessoAta'(){
        //     this.idProcessoAta = null
        //     if (this.convenio.idProcessoAta>0){
        //         this.idProcessoAta = this.convenio.idProcessoAta
        //         for (var i = 0, l = this.convenio.processosAta.length; i <= l; i++) {
        //             if (this.convenio.processosAta[i].idProcessoAta == this.convenio.idProcessoAta){
        //                 this.convenio.vcObjeto = this.convenio.processosAta[i].vcObjetoProcesso
        //                 //this.convenio.nuValorConvenio = this.convenio.processosAta[i].nuValorGlobalProcesso
        //                 return
        //             }
        //         }
        //     }
        // },
        'convenio.codGestor'(){
           this.codGestor = null
            if (this.convenio.codGestor > 0){
                this.codGestor = this.convenio.codGestor
            }
        },
        // 'convenio.codUnidade'(){
        //    this.codUnidade = null
        //     if (this.convenio.codUnidade > 0){
        //         this.codUnidade = this.convenio.codUnidade
        //     }
        // },
        'convenio.codTipoConvenio'(){
           this.codTipoConvenio = null
            if (this.convenio.codTipoConvenio > 0){
                this.codTipoConvenio = this.convenio.codTipoConvenio
            }
        },
        'convenio.codTipoProdutoFaturamento'(){
           this.codTipoProdutoFaturamento = null
            if (this.convenio.codTipoProdutoFaturamento > 0){
                this.codTipoProdutoFaturamento = this.convenio.codTipoProdutoFaturamento
            }
        },
        'convenio.codTipoNatureza'(){
           this.codTipoNatureza = null
            if (this.convenio.codTipoNatureza.length > 0){
                this.codTipoNatureza = this.convenio.codTipoNatureza
            }
        },
        'convenio.codGestorRM'(){
           this.codGestorRM = null
            if (this.convenio.codGestorRM > 0){
                this.codGestorRM = this.convenio.codGestorRM
            }
        },
        'convenio.codGerenteGestor'(){
           this.codGerenteGestor = null
            if (this.convenio.codGerenteGestor > 0){
                this.codGerenteGestor = this.convenio.codGerenteGestor
            }
        },
        'convenio.codRepresentante'(){
           this.codRepresentante = null
            if (this.convenio.codRepresentante > 0){
                this.codRepresentante = this.convenio.codRepresentante
            }
        },
        'convenio.gestor.codFuncionario'(novo){
            this.convenio.gestor.codFuncionario = novo
            this.convenio.codGestor = this.convenio.gestor.codFuncionario
        }

        // nuValorRecebimento(novo) {
        //     this.nuValorRecebimento = novo
        //     this.cronogramaRecebimento.nuValorRecebimento = this.nuValorRecebimento
        // }
    },


    created() {
        this.obterGestores()
        // this.obterUnidades()
        this.obterConvenio()
        this.obterTiposConvenios()
        this.ObterTipoProdutoFaturamento()
        this.ObterTipoNatureza()
        this.ObterVendedores()
        this.ObterRepresentantes()
    },

}
</script>
